import React from 'react';
import CompanyBrandCell from '../../../components/CompanyBrandCell';
import SecFilingPriorityPill from './SecFilingPriorityPill';

const formatValue = (value) => (value ? value : '—');

export default function SecFilingTableRow({
  row,
  rowIndex,
  startIndex = 0,
  isSelected = false,
  subjectCompany = '',
  onSelect,
}) {
  return (
    <tr
      className={[
        row.isCritical ? 'sec-filing-insights-data-table__row--critical' : '',
        isSelected ? 'selected' : '',
      ].filter(Boolean).join(' ')}
      style={{ '--table-row-delay': rowIndex }}
      onClick={() => onSelect?.(row.id)}
    >
      <td className="col-sno sec-filing-insights-data-table__sno">
        {startIndex + rowIndex + 1}
      </td>
      <td className="col-company company-cell">
        <div className="sec-filing-table__company-name">
          <CompanyBrandCell
            companyName={row.company || row.companyShort}
            subjectCompany={subjectCompany}
          />
        </div>
      </td>
      <td className="col-entity">
        {row.entityHeaderDisplay ? (
          <div className="sec-filing-table__entity-header" title={row.entityHeaderDisplay}>
            {row.entityHeaderDisplay}
          </div>
        ) : (
          formatValue(row.entity)
        )}
      </td>
      <td className="col-type">{formatValue(row.filingType)}</td>
      <td className="col-priority">
        <SecFilingPriorityPill isCritical={row.isCritical} />
      </td>
      <td className="col-accepted date-cell">
        <div className="sec-filing-table__accepted-date">
          {row.acceptedAtDateDisplay || row.acceptedAtDisplay || '—'}
        </div>
        {row.acceptedAtTimeDisplay ? (
          <div className="sec-filing-table__accepted-time">{row.acceptedAtTimeDisplay}</div>
        ) : null}
      </td>
      <td className="col-date date-cell">{row.filedDateDisplay}</td>
      <td className="col-file-film sec-filing-table__file-film">
        <div className="sec-filing-table__file-num">{row.fileNumberDisplay}</div>
        <div className="sec-filing-table__film-num">{row.filmNumberDisplay}</div>
      </td>
    </tr>
  );
}
